<template>
  <div class="main-cont">
    <div class="coll-sel" v-if="deptLevelCode == '001'">
      <el-select v-model="deptId" placeholder="请选择学院" @change="deptChange">
        <el-option
          v-for="item in collegeList"
          :key="item.uuid"
          :label="item.deptName"
          :value="item.uuid"
        ></el-option>
      </el-select>
    </div>
    <TopStat :statisInfo="classTopInfo" @changeYear="changeYear"/>
    <div class="tab-item">
      <div class="cat-name">班级分类</div>
      <div id="chart-class"></div>
    </div>
    <onlineClassChart :deptId="deptId" />
    <!-- <div class="squ-view" v-if="blockNums">
      <div class="squ-item" v-for="item in basics" :key="item.val">
        <div class="item-top">{{ blockNums[item.val] || 0 }}</div>
        <div class="item-bott">{{ item.paramName }}</div>
      </div>
    </div> -->

    
    <div class="cat-name">
      学习明细
      <div class="search_right">
        <Search ref="search" @search="search" />
      </div>
    </div>
    <Table :data="listData" @showWork="showWork" @showText="showText" />
    <div class="RCPagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <WorkDia :workDia="workDia" :workData="workData" @closeDia="closeDia" />
    <TestDia :testDia="testDia" :testData="testData" @closeDia="closeDia" />
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import { getItem } from "@/utils/storage";
import { statisticDeptList } from "@/api/dept";
import {
  findClassStatistics,
  findClassStatisticsNew,
  findClassDetailStatistics,
  findClassWorkStatistics,
  findExamStatistics,
} from "@/api/class";
import Search from "./search";
import Table from "./table.js";
import WorkDia from "./workDia.vue";
import TestDia from "./testDia.vue";
import TopStat from "./components/top.vue"
import onlineClassChart from './components/onlineClassChart.vue'

export default {
  name: "classStatistics",
  components: {
    Search,
    Table,
    WorkDia,
    TestDia,
    TopStat,
    onlineClassChart
  },
  data() {
    return {
      collegeList: [],
      classCategory: [],
      deptId: "",
      deptLevelCode: getItem("deptLevelCode"),
      load: false,
      blockNums: {},
      chart: null,
      basics: [
        { paramName: "开班总数", val: "totalNum" },
        { paramName: "线上班级数", val: "classUpNum" },
        { paramName: "线下班级数", val: "classDownNum" },
      ],
      listData: [],
      page: 1,
      limit: 10,
      total: 0,
      workDia: {
        show: false,
        title: "作业详情",
      },
      testDia: {
        show: false,
        title: "考试详情",
      },
      workData: [],
      testData: [],
      queryParams: {},
      year: "",
      classTopInfo: {
        totalNum: 0,
          totalEnrollNum: 0,
          classList: [
            { name: '网络专题培训班', totalNum: 0, notStartNum: 0, trainingNum: 0, endNum: 0, enrollNum: 0 },
            { name: '脱产培训班', totalNum: 0, notStartNum: 0, trainingNum: 0, endNum: 0, enrollNum: 0 },
            { name: '中组部选调班', totalNum: 0, notStartNum: 0, trainingNum: 0, endNum: 0, enrollNum: 0 },
          ]
      }
    };
  },
  watch: {
    classCategory: {
      handler(val, oldVal) {
        // console.log(val, oldVal);
        this.changeChart(val);
      },
      deep: true,
    },
  },
  mounted() {
    this.drawChart(this.classCategory);
    // this.changeChart(this.classCategory);
  },
  methods: {
    handleSizeChange(s) {
      this.limit = s;
      this.page = 1;
      this.queryDeatil(this.queryParams);
    },
    handleCurrentChange(p) {
      this.page = p;
      this.queryDeatil(this.queryParams);
    },
    closeDia(val) {
      this[val].show = false;
    },
    showWork(id) {
      findClassWorkStatistics(id).then(({ code, data }) => {
        if (code === 0) {
          this.workData = data;
          this.workDia.show = true;
        }
      });
    },
    showText(id) {
      findExamStatistics(id).then(({ code, data }) => {
        if (code === 0) {
          this.testData = data;
          this.testDia.show = true;
        }
      });
    },
    search(param = {}) {
      this.queryParams = param;
      this.queryDeatil(param);
    },
    deptChange(val) {
      this.deptId = val;
      this.getNumAndType();
      this.$refs.search.resetData();
    },
    changeYear(year) {
      this.year = year;
      this.getNumAndType();
    },
    getNumAndType() {
      findClassStatisticsNew({ deptId: this.deptId, year: this.year }).then(({ code, data }) => {
        if (code === 0) {
          this.classTopInfo = {
            totalNum: data.totalNum || 0,
            totalEnrollNum: data.totalEnrollNum,
            classList:data.classList
          };
          this.classCategory = data.typeList;
        }
      });
    },
    queryDeatil(q) {
      findClassDetailStatistics({
        ...q,
        deptId: this.deptId,
        page: this.page,
        limit: this.limit,
      }).then(({ code, data }) => {
        if (code === 0) {
          this.listData = data.records;
          this.total = data.total;
        }
      });
    },
    initPage() {
      if (this.deptLevelCode == '001') {
        statisticDeptList()
          .then(({ code, data }) => {
            if (code === 0) {
              this.collegeList = data;
              this.deptId = data[0].uuid;
              this.load = true;
              this.getNumAndType();
              this.queryDeatil();
            }
          })
          .catch(() => {});
      } else {
        this.load = true;
        this.getNumAndType();
        this.queryDeatil();
      }
    },
    drawChart(data) {
      const chart = new Chart({
        container: "chart-class",
        autoFit: true,
        height: 250,
        padding: [20, 20, 20, 20],
      });
      chart.data(data);
      chart.scale("num", {
        nice: true,
      });
      chart.axis("name", {
        // tickLine: null,
      });
      chart.legend(false);
      chart
        .interval()
        .position("name*num")
        .color("name", () => "#4983F5")
        .size("num", () => 20)
        .label("num", {
          style: {
            fill: "#8d8d8d",
          },
          offset: 10,
        });
      chart.render();
      this.chart = chart;
    },
    changeChart(data) {
      this.chart.clear();
      this.chart.data(data);
      this.chart.scale("num", {
        nice: true,
      });
      this.chart.axis("name", {
        tickLine: null,
      });
      this.chart.legend(false);
      this.chart
        .interval()
        .position("name*num")
        .color("name", () => "#4983F5")
        .size("num", () => 20)
        .label("num", {
          style: {
            fill: "#8d8d8d",
          },
          offset: 10,
        });
      this.chart.render();
    },
  },
  created() {
    this.initPage();
  },
};
</script>

<style lang="scss" scoped>
.main-cont {
  padding: 20px 24px;
  .coll-sel {
    margin-bottom: 30px;
  }
  .squ-view {
    display: flex;
    margin: 0 -8px;
    .squ-item {
      margin: 0 8px;
      flex: 1;
      height: 112px;
      text-align: center;
      background: #f5f7fc;
      &:hover {
        background: #ffffff;
        box-shadow: 0px 5px 11px 3px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
      }
      .item-top {
        padding: 21px 0 5px 0;
        font-size: 32px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #343c4a;
        line-height: 39px;
      }
      .item-bott {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #51627d;
        line-height: 17px;
      }
    }
  }
  .tab-item {
    padding: 20px 0px;
    padding-top: 10px;
  }
  .cat-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #343c4a;
    line-height: 40px;
    padding: 19px 0 12px 0;
  }
}
</style>